// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticleToolbar-cls1_9ie","cls2":"ArticleToolbar-cls2_S7e ArticleToolbar-cls1_9ie"};